import { Icon, IIconProps } from 'native-base';
import { Path } from 'react-native-svg';

export const Building01Icon = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 18" fill="none" {...props}>
      <Path
        d="M6.24999 8.16667H3.83332C3.36661 8.16667 3.13326 8.16667 2.955 8.25749C2.7982 8.33739 2.67071 8.46487 2.59082 8.62167C2.49999 8.79993 2.49999 9.03329 2.49999 9.5V16.5M13.75 8.16667H16.1667C16.6334 8.16667 16.8667 8.16667 17.045 8.25749C17.2018 8.33739 17.3293 8.46487 17.4092 8.62167C17.5 8.79993 17.5 9.03329 17.5 9.5V16.5M13.75 16.5V4.16667C13.75 3.23325 13.75 2.76654 13.5683 2.41002C13.4085 2.09641 13.1536 1.84144 12.84 1.68166C12.4835 1.5 12.0167 1.5 11.0833 1.5H8.91666C7.98324 1.5 7.51653 1.5 7.16001 1.68166C6.8464 1.84144 6.59143 2.09641 6.43165 2.41002C6.24999 2.76654 6.24999 3.23325 6.24999 4.16667V16.5M18.3333 16.5H1.66666M9.16666 4.83333H10.8333M9.16666 8.16667H10.8333M9.16666 11.5H10.8333"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};
